import React from "react";
import "./CompanyInfo.scss";
import chairman from "../../../assets/About/chairman.png";
// import ceoImg from "../../../assets/About/ceo-rupali.jpg";
// import ceoImg from "../../../assets/About/rupali-ceo.png";
import ceoImg from "../../../assets/About/rupali-ceo-sm.png";

import UseCompanyInfo from "../../../hooks/UseCompanyInfo";
import UseBranchInfo from "../../../hooks/UseBranchInfo";

const CompanyInfo = () => {
  const [companyInfo, setCompanyInfo, loading] = UseCompanyInfo();

  const [branchInfo] = UseBranchInfo();

  const {
    CFOName,
    Incorporation,
    CommencementofBusiness,
    ChairmanName,
    SecretaryName,
    AuditorsName,
    LegalConsultant,
    ListingWithDSE,
    ListingCSE,
    Address,
    CEOName,
    Advisor,
  } = companyInfo;

  return (
    <>
      <div className="company_info">
        <div className="container">
          <div className="heading_box">Company Information</div>
          <div className="info_content">
            <p
              className="text-center my-5"
              style={{ fontFamily: "Inter", lineHeight: "1.5" }}
            >
              THE IMPORTANT INFORMATIONS OF THE <br />{" "}
              <b>"RUPALI INSURANCE COMPANY LIMITED"</b> <br /> ARE AS FOLLOWS:
            </p>

            {loading ? (
              <>
                <div className="row justify-content-between">
                  <div className="col-lg-5">
                    <div className="right mt-4 mt-lg-0  ">
                      <div className="ceo_content chairman_content">
                        <div className="line_rotate"></div>
                        <div className="chairman_img">
                          <img src={ceoImg} className="img-fluid" alt="" />
                        </div>
                        <div className="chairman_text">
                          <p className="mb-3">CEO (C.C)</p>
                          <h4 style={{ textTransform: "uppercase" }}>
                            {CEOName}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5 order-first order-lg-last">
                    <div className="right mb-5 mb-lg-0">
                      <div className="chairman_content">
                        <div className="line_rotate"></div>
                        <div className="chairman_img">
                          <img src={chairman} className="img-fluid" alt="" />
                        </div>

                        <div className="chairman_text">
                          <p className="mb-3">Chairman</p>
                          <h4 style={{ textTransform: "uppercase" }}>
                            {ChairmanName}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Company details information */}
                <div className="row">
                  <div className="col-lg-12 mt-4 mt-lg-0">
                    <div className="company_details_content">
                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Incorporation :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{Incorporation}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Commencement of Business :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{CommencementofBusiness}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Listing With DSE :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{ListingWithDSE}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-2 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Listing With CSE :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{ListingCSE}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Chairman :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{ChairmanName}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-2 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Advisor :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{Advisor}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Chief Executive Officer (C.C) :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{CEOName}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Chief Financial Officer :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{CFOName}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Company Secretary :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{SecretaryName}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Auditors :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{AuditorsName}</b>
                          </p>
                        </div>
                      </div>

                      <div className="row mb-3 text_row">
                        <div className="col-5 col-lg-6">
                          <h6>Legal Consultant :</h6>
                        </div>
                        <div className="col-7 col-lg-6">
                          <p>
                            <b>{LegalConsultant}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* !Company details information */}
              </>
            ) : (
              <div className="text-center my-5">
                <button className="btn btn-danger w-50" type="button">
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="container-fluid p-0">
          <div className="address_box">
            <div className="address_content"></div>

            <div className="container">
              <div className="address_text">
                <div className="row">
                  <div className="col-lg-4 mb-5 mb-lg-0">
                    <div className="d-flex justify-content-center">
                      <div className="address_icon">
                        <i className="fa-solid fa-landmark"></i>{" "}
                      </div>
                    </div>
                    <h6>Address</h6>
                    <p>{Address}</p>
                  </div>
                  <div className="col-lg-4 mb-5 mb-lg-0">
                    <div className="d-flex justify-content-center">
                      <div className="address_icon">
                        <i className="fa-solid fa-building-circle-arrow-right"></i>
                      </div>
                    </div>
                    <h6>Branch Office</h6>
                    <p>{branchInfo.length}</p>
                  </div>
                  <div className="col-lg-4">
                    <div className="d-flex justify-content-center">
                      <div className="address_icon">
                        <i className="fa-solid fa-user-tie"></i>
                        {/* <i class="fa-solid fa-user-secret"></i>{" "} */}
                      </div>
                    </div>
                    <h6>Number of Employees </h6>
                    <p>407</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyInfo;
